export default __webpack_public_path__ + "static/digital-onboarding-f6d8ad52bce73b7bba19b9222e7a99b9.jpg";